import styled from 'styled-components'

import { TypeStyle } from '@syconium/little-miss-figgy'

export const Body = styled(TypeStyle.BodySmall)`
  padding: 0 4px;
  position: sticky;
  top: 0;
`
